import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import ApiCall from "../../utils/Api";
import Provider_Name from "../Provider Permissions Detail Dialog/Provider Name";
import Provider_Email from "../Provider Permissions Detail Dialog/Provider Email";
import Provider_image from "../Provider Permissions Detail Dialog/Provider image";
import Provider_Share from "../Provider Permissions Detail Dialog/Provider Share";
import Status from "../Provider Permissions Detail Dialog/Status";
import Streaming_Activity from "../Provider Permissions Detail Dialog/Streaming Activity";

// const [changeColor,setchangeColor]=useState("")

export default function PermissionsDetailTable({
  data,
  setupdateCount,
  updateCount,
  id,
}) {
  console.log("🚀 ~ PermissionsDetailTable ~ data:", data);
  return (
    <TableContainer style={{ borderRadius: 9 }} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{ backgroundColor: "Black" }}>
          <TableRow>
            <TableCell align="center" style={{ color: "white" }}>
              Name
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}></TableCell>
            <TableCell align="center" style={{ color: "white" }}></TableCell>

            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Institution Name</TableCell>
            <TableCell align="center">
              <span style={{ padding: 10, paddingLeft: 30, paddingRight: 30 }}>
                {data?.institutionName}
              </span>
            </TableCell>
            <TableCell align="center">
              {" "}
              <Provider_Name
                providerName={data?.institutionName}
                setupdateCount={setupdateCount}
                ownerSplit={data?.ownerSplit}
                ProviderSplit={data?.ProviderSplit}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Code</TableCell>
            <TableCell align="center">
              <span style={{ padding: 10, paddingLeft: 30, paddingRight: 30 }}>
                {data?.institutionCode}
              </span>
            </TableCell>
            <TableCell align="center">
              {" "}
              <Provider_image
                providerEmail={data?.institutionCode}
                setupdateCount={setupdateCount}
                ownerSplit={data?.ownerSplit}
                ProviderSplit={data?.ProviderSplit}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Email</TableCell>
            <TableCell align="center">
              <span style={{ padding: 10, paddingLeft: 30, paddingRight: 30 }}>
                {data?.email}
              </span>{" "}
            </TableCell>
            <TableCell align="center">
              {" "}
              <Provider_Email
                providerEmail={data?.email}
                institutionName={data?.institutionName}
                setupdateCount={setupdateCount}
                ownerSplit={data?.ownerSplit}
                ProviderSplit={data?.ProviderSplit}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>

          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Registered</TableCell>
            <TableCell align="center">
              <span
                style={{
                  background: data?.isApproved
                    ? "rgba(47, 183, 77, 0.13)"
                    : "rgba(222, 23, 23, 0.13)",
                  color: data?.isApproved
                    ? "rgba(47, 183, 77, 1)"
                    : "rgba(222, 23, 23, 1)",
                  padding: 10,
                  paddingLeft: 30,
                  paddingRight: 30,
                }}
              >
                {data?.isApproved ? "Yes" : "No"}
              </span>{" "}
            </TableCell>
            <TableCell align="center"> </TableCell>
          </TableRow>

          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Streaming Activity</TableCell>
            <TableCell align="center">
              <span
                style={{
                  background: data?.StreamingActivity
                    ? "rgba(47, 183, 77, 0.13)"
                    : "rgba(222, 23, 23, 0.13)",
                  color: data?.StreamingActivity
                    ? "rgba(47, 183, 77, 1)"
                    : "rgba(222, 23, 23, 1)",
                  padding: 10,
                  paddingLeft: 30,
                  paddingRight: 30,
                }}
              >
                {data?.StreamingActivity ? "Yes" : "No"}
              </span>{" "}
            </TableCell>
            <TableCell align="center">
              {" "}
              <Streaming_Activity
                setupdateCount={setupdateCount}
                updateCount={updateCount}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">
              <span
                style={{
                  background: data?.status
                    ? "rgba(47, 183, 77, 0.13)"
                    : "rgba(222, 23, 23, 0.13)",
                  color: data?.status
                    ? "rgba(47, 183, 77, 1)"
                    : "rgba(222, 23, 23, 1)",
                  padding: 10,
                  paddingLeft: 30,
                  paddingRight: 30,
                }}
              >
                {data?.status ? "White listed" : "Black listed"}
              </span>{" "}
            </TableCell>

            <TableCell align="center">
              {" "}
              <Status
                setupdateCount={setupdateCount}
                updateCount={updateCount}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell align="center">Split %</TableCell>
            <TableCell align="center">
              {data?.ownerSplit} : {data?.ProviderSplit}
            </TableCell>
            <TableCell align="center">
              {" "}
              <Provider_Share
                institutionName={data?.institutionName}
                setupdateCount={setupdateCount}
                ownerSplit={data?.ownerSplit}
                ProviderSplit={data?.ProviderSplit}
                id={id}
              />{" "}
            </TableCell>
          </TableRow>
          {/* <TableCell align="center"><span style={{background:row.registered=="Yes"?"rgba(47, 183, 77, 0.13)":"rgba(222, 23, 23, 0.13)",color:row.registered=="Yes"?"rgba(47, 183, 77, 1)":"rgba(222, 23, 23, 1)",padding:10,paddingLeft:30,paddingRight:30}}>{row.registered}</span> </TableCell>
              <TableCell align="center" ><span style={{background:row.status=="Active"?"rgba(47, 183, 77, 0.13)":"rgba(155, 155, 155, 0.13)",color:row.status=="Active"?"rgba(47, 183, 77, 1)":"rgba(155, 155, 155, 1)",padding:10,paddingLeft:30,paddingRight:30}}>{row.status}</span></TableCell> */}
          {/* <TableCell align="center"><Link to="PermissionsDetail">View Detail</Link></TableCell> */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
